import { Megaphone } from 'lucide-react';
import { Button, Card, Description, Heading } from '@heroui/react';

interface BulkRequestPromoProps {
  onOpenBulkRequest: () => void;
}

export function BulkRequestPromo({ onOpenBulkRequest }: BulkRequestPromoProps) {
  return (
    <Card data-tour="bulk-request-promo">
      <Card.Content className="flex flex-col items-stretch gap-5 p-5">
        <div className="flex items-start gap-3">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-accent-soft text-accent">
            <Megaphone size={20} />
          </div>
          <div>
            <Heading level={3} className="text-base font-semibold">
              Não encontrou vaga no período?
            </Heading>
            <Description>
              Envie uma solicitação em massa para os proprietários do condomínio. Algum morador
              pode ter uma vaga para emprestar.
            </Description>
          </div>
        </div>
        <Button variant="primary" size="lg" className="w-full" onPress={onOpenBulkRequest}>
          <Megaphone size={18} />
          Solicitar em massa
        </Button>
      </Card.Content>
    </Card>
  );
}
